import { createContext, PropsWithChildren, useContext } from "react";

import { HamletClient, IHamletClient } from "@atlassiansox/asc-hamlet";

const HamletClientContext = createContext<IHamletClient>(new HamletClient());

export function useHamletClient(): IHamletClient {
    return useContext(HamletClientContext);
}

export type HamletClientProviderProps = PropsWithChildren<{
    readonly client: IHamletClient;
}>;

export const HamletClientProvider = ({
    client,
    children
}: HamletClientProviderProps) => {
    return (
        <HamletClientContext.Provider value={client}>
            {children}
        </HamletClientContext.Provider>
    );
};
